import React from "react";

const ShowError = ({ message, size = "small", color = "red" }) => {
    return (
        <div style={{ color: color, fontSize: size, marginLeft: "3px" }}>{message}</div>
    )
};

export default ShowError;
